Ext.define('SA.ImportRequestErrorWindow', {
    singleton: true,

    get({strongText}) {
        Ext.widget({
            xtype: 'prompt-window',
            includeOkBtn: true,
            includeHeader: false,
            getBodyItems: () => this.getBody(strongText)
        });
    },

    getBody(strongText) {
        return {
            xtype: 'component',
            cls: 'sa-import-request-error-window-body',

            html: [
                '<div class="sa-import-request-error-window-svg-wrap">',
                    '<svg><use href="#sa-icon-warning"></use></svg>',
                '</div>',
                '<div>',
                    `<strong>${strongText}</strong><br><br>`,
                    'Trying again may work, or for assistance, please contact us at ',
                    '<a href="mailto:support@simplyanalytics.com">support@simplyanalytics.com</a>.',
                '</div>'
            ]
        };
    }
});